import { useAuth } from '../contexts/AuthContext';

export function useCurrentOrgRole(): string | undefined {
  const { backendUser, currentOrganization } = useAuth();

  if (!backendUser || !currentOrganization) {
    return undefined;
  }

  const memberships: Array<{
    organization?: { id: string };
    organizationId?: string;
    id?: string;
    role: string;
  }> = backendUser.organizationMembers ?? backendUser.organizations ?? [];

  const membership = memberships.find(
    (m) => (m.organization?.id ?? m.organizationId ?? m.id) === currentOrganization.id,
  );

  return membership?.role ?? 'sales_rep';
}
